<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12>
        <v-layout column>
          <v-flex d-flex v-for="(questionnaire, i) in questionnaires" :key="`questionnaire-${i}`">
            <v-card flat color="text-xs-justify" tile>
              <v-card-title>
                <div>
                  <div class="subheading">{{ questionnaire.answerSet.phase }}</div>
                  <div v-if="questionnaire.answerSet.submittedAt">
                    <v-icon small class="text-vertical-middle">mdi-calendar</v-icon>
                    {{ new Date(questionnaire.answerSet.submittedAt) | date('do MMM yyy') }}
                  </div>
                  <div v-else class="warning--text text-xs-center">
                    <v-icon small class="text-vertical-middle" color="warning">mdi-alert</v-icon>
                    Answers have <strong>NOT</strong> been submitted
                  </div>
                </div>
              </v-card-title>
              <v-divider v-if="questionnaire.answerSet.submittedAt" />
              <div v-if="questionnaire.answerSet.submittedAt">
                <div v-for="({ question, answer }, j) in sortQuestions(questionnaire.questions)" :key="`${i}-question-${question.position}`">
                  <v-card-title class="pb-1">
                    <strong>{{ j + 1 }}. {{ question.title }}</strong>
                  </v-card-title>
                  <v-card-text class="pt-0 px-4" v-if="question.type === 'text' && answer && answer.content">
                    {{ answer.content }}
                  </v-card-text>
                  <v-card-text class="pt-0 px-4" v-else-if="question.type === 'file' && answer && answer.attachment">
                    <v-btn target="_blank" :href="answer.attachment.url" block :color="themes.client.light.secondaryActionButton">
                      View
                      <v-icon right>mdi-cloud-download</v-icon>
                    </v-btn>
                  </v-card-text>
                  <v-card-text class="pt-0 px-4" v-else-if="question.type === 'choice' && answer && answer.content">
                    {{ answer.content }}
                  </v-card-text>
                  <v-card-text class="pt-0 px-4" v-else>
                    <v-icon v-if="!question.optional">warning</v-icon>
                    <em>No answer was submitted.</em>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { byPosition, bySubmittedAt } from '@/sorting/QuestionnaireQuestions'

export default {
  props: { value: [Object, Array] },
  computed: {
    questionnaires() {
      return JSON.parse(JSON.stringify(this.value)).sort(bySubmittedAt({ asc: false }))
    }
  },
  methods: {
    sortQuestions(questions) {
      return questions
      if (questions && questions[0]) {
        return questions.sort(byPosition())
      }
      return []
    }
  }
}
</script>
